import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getSeoDescription } from '@/stores/slices/titleSlice';
import { useEffect, useRef } from 'react';

function useDescription(description, set = true) {
	const location = useLocation();
	const seoDescription = useSelector(getSeoDescription);
	const timeoutRef = useRef(null);

	useEffect(() => {
		if (!set) return;

		const content = seoDescription || description;

		timeoutRef.current = setTimeout(() => {
			let metaTag = document.querySelector('meta[name="description"]');
			let metaOgTag = document.querySelector(
				'meta[property="og:description"]',
			);

			if (!metaTag) {
				metaTag = document.createElement('meta');
				metaTag.setAttribute('name', 'description');
				document.head.appendChild(metaTag);
			}
			if (!metaOgTag) {
				metaOgTag = document.createElement('meta');
				metaOgTag.setAttribute('property', 'og:description');
				document.head.appendChild(metaOgTag);
			}
			metaOgTag.setAttribute('content', content);
			metaTag.setAttribute('content', content);
		}, 400);

		return () => {
			if (timeoutRef.current) {
				console.warn(`=> abort title setup. reason: new data`);
				clearTimeout(timeoutRef.current);
			}
		};
	}, [location, description, set, seoDescription]);
}

export default useDescription;
